import { Injectable, inject } from '@angular/core';
import {
  IListado,
  IQueryParam,
  IPortico,
  ICreatePortico,
  IUpdatePortico,
} from 'modelos/src';
import { Observable, from } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';
import { StorageService } from '../../auxiliares/servicios/storage.service';

@Injectable({
  providedIn: 'root',
})
export class PorticosService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);
  private storage = inject(StorageService);

  public listar(queryParams?: IQueryParam): Observable<IListado<IPortico>> {
    const params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/porticos`, { params });
  }

  public listarPorId(id: string): Observable<IPortico> {
    return this.http.get(`/porticos/${id}`);
  }

  public crear(dato: ICreatePortico): Observable<IPortico> {
    return this.http.post(`/porticos`, dato);
  }

  public editar(id: string, dato: IUpdatePortico): Observable<IPortico> {
    return this.http.put(`/porticos/${id}`, dato);
  }

  public eliminar(id: string): Observable<IPortico> {
    return this.http.delete(`/porticos/${id}`);
  }

  public subirImagen(
    file: File,
    nombreCLiente: string,
    nombreImagen: string,
    nombreCategoria?: string,
  ): Observable<{ url: string }> {
    return from(
      this.storage.subirImagenCliente(
        file,
        nombreCLiente,
        nombreImagen,
        nombreCategoria,
      ),
    );
  }

  public subirImagenPublica(
    file: File,
    fileName: string,
  ): Observable<{ url: string }> {
    return from(this.storage.subirImagenPublica(file, fileName));
  }
}
